import {css} from "@emotion/react";

export const editDeleteContainer = css`
    display: grid;
    padding-top: 5px;
    justify-content: flex-end;
    width: 100%;
    grid-template-columns: auto auto;
`;

export const errorSpan = css`
    margin-top: 4px;
    padding-right: 10px;
    font-size: 13px;
    color: #ff0000;
`;

export const bigError = css`
    text-align: right;
    width: 100%;
    margin-top: 14px;
    padding-right: 10px;
    font-size: 16px;
    color: red;
`;

